import { Injectable } from '@angular/core';
import { IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { ImportExportGateway } from '../api/gateways';
import { EMessageType } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class ImportExportService<T, D> {
  constructor(private readonly gateway: ImportExportGateway<T, FormData, D>) {}

  downloadFile(requestData: D, filename: string = 'export.csv'): void {
    this.gateway
      .download(requestData)
      .subscribe((response: IApiResponse<string>) => {
        if (response.message?.type === EMessageType.SUCCESS) {
          const blob = new Blob([response.data!], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          window.URL.revokeObjectURL(url);
        }
      });
  }

  private getFilenameFromHeader(
    contentDisposition: string | null
  ): string | null {
    if (!contentDisposition) return null;

    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
      contentDisposition
    );
    if (!matches || matches.length < 2) return null;

    return matches[1].replace(/['"]/g, '');
  }

  uploadFile(formData: FormData): Observable<IApiResponse<T>> {
    return this.gateway.upload(formData);
  }
}
